import type { ZodTypeAny } from 'zod';
import { z } from 'zod';

import type { FieldDescriptor } from '../../types/common';

import { MultiSelectFieldElement } from './MultiSelectField';
import type { MultiSelectField } from './types';

const createValidationSchema = (field: MultiSelectField) => {
  let fieldSchema: ZodTypeAny = z.array(z.union([z.string(), z.number(), z.boolean()]), {
    required_error: 'Please select at least one option',
  });

  if (field.validation?.min) {
    const message =
      field.validation.minErrorMessage || `Please select at least ${field.validation.min} options`;
    // @ts-expect-error Some weird typing
    fieldSchema = fieldSchema.min(field.validation.min, {
      message,
    });
  }

  if (field.validation?.isOptional) {
    fieldSchema = fieldSchema.optional();
  }

  return fieldSchema;
};

const Descriptor: FieldDescriptor<MultiSelectField> = {
  FieldComponent: MultiSelectFieldElement,
  name: 'MultiSelectField',
  createValidationSchema,
};

export default Descriptor;

export type { MultiSelectField as FieldType };
